import { createDialog } from '@patsnap/tahiti-core';

export interface ImageSelectorDialogOptions {
    title?: string;
    maxSelection?: number;
    selectedImages?: string[];
    availableImages?: ImageItem[];
}

export interface ImageItem {
    url: string;
    s3Key: string;
    uniqueId: string;
}

export interface ImageSelectorDialogResult {
    selectedImages: ImageItem[];
}

export const imageSelectorDialogServiceFactory = createDialog(() => import('../../components/ImageSelectorDialog.vue'));
